@if (display() === 'show') {
    <a routerLink="/">
        <img src="quorum-logo.png" class="app-logo h-10 w-auto">
    </a>
}
@else {
    <img src="quorum-logo.png" class="app-logo h-10 w-auto opacity-0">
}

